import { ParamIds, Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class RegraFormKeys extends MainKeys {
    get place() {
        return Places.mcRegraForm
    }

    public get regraId() {
        return this._intent.getParameterAsNumber(ParamIds.mcRegraFormId)
    }

    public set regraId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcRegraFormId, value)
    }

    public get analiseId() {
        return this._intent.getParameterAsNumber(ParamIds.mcAnaliseFormId)
    }

    public set analiseId(value: number | undefined) {
        this._intent.setParameter(ParamIds.mcAnaliseFormId, value)
    }
}
export default RegraFormKeys
